import React from 'react';
import { Stack, Text } from '@/theme/index';
import { SmartInsightTabStarRating } from './SmartInsightTabStarRating/SmartInsightTabStarRating';
import { StyledDivider } from './components';

interface SmartInsightsToggleButtonContentsProps {
  value: number;
  displayText: string;
}

export const SmartInsightsToggleButtonContents = ({
  value,
  displayText,
}: SmartInsightsToggleButtonContentsProps) => {
  const getDividerClassNameFromRank = (rank: number) => {
    switch (rank) {
      case 3: {
        return 'green';
      }
      case 2: {
        return 'yellow';
      }
      case 1: {
        return 'red';
      }
      default: {
        return '';
      }
    }
  };

  return (
    <Stack width="100%" flex={1} height="inherit">
      <Stack
        direction={{ xs: 'column-reverse', sm: 'row' }}
        justifyContent="space-around"
        alignItems="center"
        width="100%"
        flexGrow={1}
        margin={{ xs: '1rem 0 0.75rem 0', sm: '0' }}
      >
        <Text fontWeight="700" lineHeight="1.75rem">
          {displayText}
        </Text>
        <SmartInsightTabStarRating value={value} />
      </Stack>
      <StyledDivider className={getDividerClassNameFromRank(value)} />
    </Stack>
  );
};
